import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header";
import BannerImage from "../../assets/images/about/compliance-comettee.png"
import Icon1Image from "../../assets/images/placement/icon21.png"
import Icon2Image from "../../assets/images/placement/icon22.png"
import Icon3Image from "../../assets/images/placement/icon23.png"
import DrugImage from "../../assets/images/student-life/drug.png"
import DressImage from "../../assets/images/student-life/dress.png"
import HostelImage from "../../assets/images/student-life/hostel.png"

import VisionImage from "../../assets/images/about/vision.png"
import { useState } from "react";
import Table from 'react-bootstrap/Table';

const ComplianceCommittee = () => {
    const [gravience, setGravience] = useState(true)
    const [Complaint, setComplaint] = useState(false)
    const [Ragging, setRagging] = useState(false)
    const [SCST, setSCST] = useState(false)
    const [studentcounsellor, setStudentCounsellor] = useState(false)
    const [divyang, setDivyang] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const gravienceHandler = () => {
        setGravience(true)
        setComplaint(false)
        setRagging(false)
        setSCST(false)
        setStudentCounsellor(false)
        setDivyang(false)

    }
    const ComplaintHandler = () => {
        setGravience(false)
        setComplaint(true)
        setRagging(false)
        setSCST(false)
        setStudentCounsellor(false)
        setDivyang(false)


    }
    const RaggingHandler = () => {
        setGravience(false)
        setComplaint(false)
        setRagging(true)
        setSCST(false)
        setDivyang(false)
        setStudentCounsellor(false)

    }
    const SCSTHandler = () => {
        setGravience(false)
        setComplaint(false)
        setRagging(false)
        setSCST(true)
        setStudentCounsellor(false)
        setDivyang(false)

    }
    const StudentCounsellorHandler = () => {
        setGravience(false)
        setComplaint(false)
        setRagging(false)
        setSCST(false)
        setStudentCounsellor(true)
        setDivyang(false)
    }
    const DivyangHandler = () => {
        setGravience(false)
        setComplaint(false)
        setRagging(false)
        setSCST(false)
        setStudentCounsellor(false)
        setDivyang(true)
    }

    return (
        <Fragment>
            <Header></Header>
            <div className="col bannerCont">
                <img src={BannerImage} alt="" className="imgRes" />
                <h2 className="bannerTitleAbout leftAlignBannerTxt whiteText">Compliance<br />Committee</h2>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h3 className="blockTitle">Student Life &#62; <span> Compliance Committee</span></h3>
                    </div>
                </div>
            </div>
            <div className="backgroundGreyPlain paddingBottom3em">
                <div className="container">
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-2 cursorPointer" onClick={gravienceHandler}>
                            <div className={gravience ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon1Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle">Grievance<br />
                                    Committee 2025-26</h3>
                            </div>
                        </div>
                        <div className="col-md-2 cursorPointer" onClick={ComplaintHandler} >
                            <div className={Complaint ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon2Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle">Internal Compliance Committee <br />
                                    2025-26</h3>
                            </div>
                        </div>
                        <div className="col-md-2 cursorPointer" onClick={RaggingHandler}>
                            <div className={Ragging ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon3Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle text-center">Anti-Ragging<br />
                                    Committee 2025-26</h3>
                            </div>

                        </div>
                        <div className="col-md-2 cursorPointer" onClick={SCSTHandler}>
                            <div className={SCST ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon1Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle">SC/ST<br />
                                    Committee 2025-26</h3>
                            </div>
                        </div>

                        <div className="col-md-2 cursorPointer" onClick={StudentCounsellorHandler}>
                            <div className={studentcounsellor ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon2Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle">Student Counsellor & Divyang Cell Committee 2025-26<br />
                                </h3>
                            </div>
                        </div>

                        {/* <div className="col-md-2 cursorPointer" onClick={DivyangHandler}>
                            <div className={studentcounsellor ? "colClickBox minHeight190" : "colClickBox"}>
                                <div className="clickIconBOx">
                                    <img src={Icon3Image} alt="" className="clickBoxIcon" />
                                </div>
                                <h3 className="blockTitle">Divyang Cell  2025-26<br />
                                </h3>
                            </div>
                        </div> */}
                        <div className="col-md-1"></div>

                        <br />
                        <br />



                        {gravience &&
                            <div className="paddingLeft">
                                <div className="col-md-12 padding15px whiteBackground">
                                    <p className="paddingTop1em">According to AlCTE's Establishment of Mechanism for Grievance Redressal, Regulation 2012, the Grievance Redressal Committee
                                        has been constituted with the objective of resolving the grievances of students, parents and others. All the aggrieved students, their
                                        parents and others may henceforth approach the Grievance Redressal Committee.</p>

                                    <p className="text-center"><b>Staff Grievance Cell 2025-26</b></p>
                                    <div className="col-md-12">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Designation in Committee</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Chairperson</td>
                                                    <td>9922802674</td>
                                                    <td><a href="mailto:arvind.burande@indiraisbs.ac.in">arvind.burande@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Dr. Simarpreet Kaur</td>
                                                    <td>Secretary</td>
                                                    <td>9915617483</td>
                                                    <td><a href="mailto:simarpreet.kaur@indiraisbs.edu.in">simarpreet.kaur@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Hetal Bhinde</td>
                                                    <td>Faculty Member</td>
                                                    <td>7709285089</td>
                                                    <td><a href="mailto:hetal.bhinde@indiraisbs.edu.in">hetal.bhinde@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Faculty Member</td>
                                                    <td>9923317264</td>
                                                    <td><a href="mailto:manisha.maddel@indiraisbsmba.edu.in">manisha.maddel@indiraisbsmba.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>Ms. Nayana Moray</td>
                                                    <td>Non-teaching staff member</td>
                                                    <td>9881303595</td>
                                                    <td><a href="mailto:nayana.moray@indiraisbs.ac.in">nayana.moray@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>Mr. Rushikesh Pawade</td>
                                                    <td>Non-teaching staff member</td>
                                                    <td>7028062843</td>
                                                    <td><a href="mailto:rushikesh.pawade@indiraisbs.edu.in">rushikesh.pawade@indiraisbs.edu.in</a></td>
                                                </tr>

                                            </tbody>

                                        </Table>
                                    </div>



                                    <p className="text-center"><b>Student Grievance Committee 2025-26</b></p>

                                    <div className="col-md-12">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Designation in Committee</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Chairperson</td>
                                                    <td>9922802674</td>
                                                    <td><a href="mailto:arvind.burande@indiraisbs.ac.in">arvind.burande@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Prof. Purva Agarwal</td>
                                                    <td>Secretary</td>
                                                    <td>8308802320</td>
                                                    <td><a href="mailto:purva.agarwal@indiraisbs.ac.in">purva.agarwal@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Member - Faculty Coordinator</td>
                                                    <td>9923317264</td>
                                                    <td><a href="mailto:manisha.maddel@indiraisbsmba.edu.in">manisha.maddel@indiraisbsmba.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Prof. Roopesh Gupta</td>
                                                    <td>Member - Faculty</td>
                                                    <td>7028922118</td>
                                                    <td><a href="mailto:roopesh.gupta@indiraisbs.edu.in">roopesh.gupta@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>Mr. Siddhant Malwal</td>
                                                    <td>Student Council Member - MBA (Batch 2025-26)</td>
                                                    <td>8275196101</td>
                                                    <td><a href="mailto:siddhant.malwal@indiraisbs.edu.in">siddhant.malwal@indiraisbs.edu.in</a></td>
                                                </tr>

                                            </tbody>

                                        </Table>
                                        <p>Online Grievance Mechanism:</p><a href="https://erp.indiraedu.com/studentEmployeeGreviance.htm" target="_blank">https://erp.indiraedu.com/studentEmployeeGreviance.htm</a>
                                    </div>

                                   


                                </div>
                            </div>
                        }
                        {Complaint &&
                            <div className="paddingLeft">
                                <div className="col-md-12 padding15px whiteBackground">
                                    <p className="paddingTop1em">Internal Complaint Committee has been constituted by the Director with the powers vested in him/her by the Governing council of
                                        Indira School of Business Studies as per the Governing Council meeting held on 29th June, 2013 to address Internal Complaint
                                        Committee (ICC) activities with the broad purpose of creating a fair workplace with gender equality. The cell is especially created to
                                        prevent or deter the commission of acts of gender inequality and sexual harassment and to provide the procedure for the resolution,
                                        settlement or prosecution of acts of sexual harassment and gender biases by taking all steps required</p>
                                    <p className="text-center"><b>The following are the Internal Complaint  Committee  2025-26 members for the Academic Year 2025-26:</b></p>




                                    <p className="text-center"><b>Internal Compliance Committee (2025-26)</b></p>
                                    <Table class="table table-responsive table-bordered" responsive>
                                        <tbody>

                                            <tr>
                                                <td><strong>Sr. No.</strong></td>
                                                <td><strong>Name of the Committee Members</strong></td>
                                                <td><strong>Designation in Committee</strong></td>
                                                <td><strong>Mobile No.</strong></td>
                                                <td><strong>E-mail-ID</strong></td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Manisha Maddel</td>
                                                <td>Teaching - Presiding Officer</td>
                                                <td>9923317264</td>
                                                <td><a href="mailto:manisha.maddel@indiraisbsmba.edu.in">manisha.maddel@indiraisbsmba.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Prof. Purva Agarwal</td>
                                                <td>Teaching - Faculty Member</td>
                                                <td>8308802320</td>
                                                <td><a href="mailto:purva.agarwal@indiraisbs.ac.in">purva.agarwal@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Prof. Roopesh Gupta</td>
                                                <td>Teaching - Faculty Member</td>
                                                <td>7028922118</td>
                                                <td><a href="mailto:roopesh.gupta@indiraisbs.edu.in">roopesh.gupta@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Dr. Amrita Karnawat</td>
                                                <td>Teaching - Faculty Member</td>
                                                <td>9420787345</td>
                                                <td><a href="mailto:amrita.karnawat@indiraisbs.ac.in">amrita.karnawat@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Mr. Rushikesh Pawade</td>
                                                <td>Non-teaching - Staff Member</td>
                                                <td>7028062843</td>
                                                <td><a href="mailto:rushikesh.pawade@indiraisbs.edu.in">rushikesh.pawade@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Ms. Shravani Khot</td>
                                                <td>Student Member (2024-26 Batch)</td>
                                                <td>8329936005</td>
                                                <td><a href="mailto:shravani.khot@indiraisbs.edu.in">shravani.khot@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Mr. Mangesh Chopade</td>
                                                <td>Student Member (2024-26 Batch)</td>
                                                <td>9552379600</td>
                                                <td><a href="mailto:mangesh.chopade@indiraisbs.edu.in">mangesh.chopade@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Ms. Gauri Kulkarni</td>
                                                <td>NGO Member</td>
                                                <td>9657998921</td>
                                                <td><a href="mailto:savali.gauri@gmail.com">savali.gauri@gmail.com</a></td>
                                            </tr>

                                        </tbody>

                                    </Table>




                                </div>
                            </div>
                        }
                        {Ragging &&
                            <div className="paddingLeft">
                                <div className="col-md-12 padding15px whiteBackground">
                                    <p className="paddingTop1em">Ragging is the term used for the so-called "initiation ritual" practiced in higher education institutions but sometimes it involves abuse,
                                        humiliation or harassment of new entrants or junior students by the senior students. It often takes a malignant form wherein the
                                        newcomers may be subjected to psychological or physical torture. Ragging has ruined countless innocent lives and careers. To root
                                        out ragging in all its forms from universities, colleges and other educational institutions this committee has been formed in every
                                        educational institute under the guidelines given by Hon’ble Supreme Court in 2007.</p>
                                    <p>ISBS has zero-tolerance policy on ragging, which is a punishable offence.
                                    </p>
                                    <p className=""><b>What Constitutes Ragging?</b></p>
                                    <p>Any disorderly conduct whether by words spoken or written or by an act which has the effect of teasing, treating or handling with
                                        rudeness any other student, indulging in rowdy or undisciplined activities which causes or is likely to cause annoyance, hardship or
                                        psychological harm or to raise fear or apprehension thereof in a fresher or a junior student or asking the students to do any act or
                                        perform something which such student will not in the ordinary course and which has the effect of causing or generating a sense of
                                        shame or embarrassment so as to adversely affect the physique or psyche of a fresher or a junior student.</p>
                                    <p>As per AICTE guidelines for Student Grievance Cell , an Online Redressal mechanism has been established and it is available to the
                                        student in his ERP login www.erp.indiraedu.co</p>
                                    <h3 className="blockTitle text-center">Anti-Ragging Committee 2025-26</h3>
                                    <Table class="table table-bordered table-responsive" responsive>
                                        <tbody>
                                            <tr>
                                                <td><strong>Sr. No.</strong></td>
                                                <td className="twidth"><strong>Name of the Committee Members</strong></td>
                                                <td><strong>Designation in Committee</strong></td>
                                                <td><strong>Mobile No.</strong></td>
                                                <td><strong>E-mail-ID</strong></td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Arvind Burande</td>
                                                <td>Chairperson</td>
                                                <td>9922802674</td>
                                                <td><a href="mailto:arvind.burande@indiraisbs.ac.in">arvind.burande@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Prof. Purva Agarwal</td>
                                                <td>Secretary</td>
                                                <td>8308802320</td>
                                                <td><a href="mailto:purva.agarwal@indiraisbs.ac.in">purva.agarwal@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Dr. Manisha Maddel</td>
                                                <td>Member Co-ordinator</td>
                                                <td>9923317264</td>
                                                <td><a href="mailto:manisha.maddel@indiraisbsmba.edu.in">manisha.maddel@indiraisbsmba.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Dr. Amrita Karnawat</td>
                                                <td>Faculty Member</td>
                                                <td>9420787345</td>
                                                <td><a href="mailto:amrita.karnawat@indiraisbs.ac.in">amrita.karnawat@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Prof. Roopesh Gupta</td>
                                                <td>Faculty Member</td>
                                                <td>7028922118</td>
                                                <td><a href="mailto:roopesh.gupta@indiraisbs.edu.in">roopesh.gupta@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>Mr. Dayanand Kamble</td>
                                                <td>Non-Teaching Member</td>
                                                <td>8446104453</td>
                                                <td><a href="mailto:dayanand.kamble@indiraisbs.ac.in">dayanand.kamble@indiraisbs.ac.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>Mr. Rushikesh Pawade</td>
                                                <td>Member (Admin Officer)</td>
                                                <td>7028062843</td>
                                                <td><a href="mailto:rushikesh.pawade@indiraisbs.edu.in">rushikesh.pawade@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>Mr. Manas Relan</td>
                                                <td>Student Member - MBA (2024-2026)</td>
                                                <td>7420000208</td>
                                                <td><a href="mailto:relan.manas@indiraisbs.edu.in">relan.manas@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>Ms. Samruddhi Mahindre</td>
                                                <td>Student Member - MBA (2024-2026)</td>
                                                <td>7038859821</td>
                                                <td><a href="mailto:samruddhi.mahindre@indiraisbs.edu.in">samruddhi.mahindre@indiraisbs.edu.in</a></td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>Adv. Nelson Narohna</td>
                                                <td>Member - Counsellor</td>
                                                <td>9665094671</td>
                                                <td><a href="mailto:adv.nelsonnoronha@gmail.com">adv.nelsonnoronha@gmail.com</a></td>
                                            </tr>
                                            <tr>
                                                <td>11</td>
                                                <td>Ms. Gauri Kulkarni</td>
                                                <td>Representative - NGO</td>
                                                <td>9657998921</td>
                                                <td><a href="mailto:savali.gauri@gmail.com">savali.gauri@gmail.com</a></td>
                                            </tr>
                                        </tbody>

                                    </Table>

                                    <h3 className="blockTitle text-center">Anti-Ragging Squad 2025-26</h3>
                                    <Table class="table table-bordered table-responsive" responsive>

                                        <tbody>
                                            <tr>
                                                <td><strong>Sr. No.</strong></td>
                                                <td class="twidth"><strong>Name of the Committee Members</strong></td>
                                                <td><strong>Designation in Committee</strong></td>
                                                <td><strong>Mobile No.</strong></td>
                                                <td><strong>E-mail-ID</strong></td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>Dr. Manisha Maddel</td>
                                                <td>Member Co-ordinator</td>
                                                <td>9923317264</td>
                                                <td>manisha.maddel@indiraisbsmba.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Dr. Amrita Karnawat</td>
                                                <td>Faculty Member</td>
                                                <td>9420787345</td>
                                                <td>amrita.karnawat@indiraisbs.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Prof. Purva Agarwal</td>
                                                <td>Secretary</td>
                                                <td>8308802320</td>
                                                <td>purva.agarwal@indiraisbs.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>Prof. Roopesh Gupta</td>
                                                <td>Faculty Member</td>
                                                <td>7028922118</td>
                                                <td>roopesh.gupta@indiraisbs.edu.in</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>Mr. Dayanand Kamble</td>
                                                <td>Non-Teaching Member</td>
                                                <td>8446104453</td>
                                                <td>dayanand.kamble@indiraisbs.ac.in</td>
                                            </tr>

                                        </tbody>

                                    </Table>
                                    <h3 className="blockTitle text-center">Women Anti Sexual Harassment Cell (2025-26)</h3>

                                    <div className="col-md-12">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Profession & Designation</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Chairman</td>
                                                    <td>9923317264</td>
                                                    <td>manisha.maddel@indiraisbsmba.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Dr. Simarpreet Kaur</td>
                                                    <td>Coordinator/ In Charge- Teaching Faculty Member</td>
                                                    <td>9915617483</td>
                                                    <td>simarpreet.kaur@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Amrita Karnawat</td>
                                                    <td>Teaching- Faculty Member</td>
                                                    <td>9420787345</td>
                                                    <td>amrita.karnawat@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Prof. Purva Agarwal</td>
                                                    <td>Teaching- Faculty Member</td>
                                                    <td>8308802320</td>
                                                    <td>purva.agarwal@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>IQAC- Teaching Faculty Member</td>
                                                    <td>9922802674</td>
                                                    <td>arvind.burande@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>Ms. Nayana Moray</td>
                                                    <td>Non-teaching- Staff member</td>
                                                    <td>9881303595</td>
                                                    <td>nayana.moray@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>Ms. Nikita Shedge</td>
                                                    <td>Student Council President- Member (2024-26 Batch)</td>
                                                    <td>7028167851</td>
                                                    <td>nikita.shedge@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>Ms. Gauri Kulkarni</td>
                                                    <td>NGO Member</td>
                                                    <td>9657998921</td>
                                                    <td>savali.gauri@gmail.com</td>
                                                </tr>
                                            </tbody>

                                        </Table>
                                    </div>





                                </div>
                            </div>
                        }


                        {SCST &&
                            <div className="paddingLeft">
                                <div className="col-md-12 padding15px whiteBackground">
                                    <p className="paddingTop1em">The Scheduled Caste (SC) and Scheduled Tribes (ST) Cell in an institute promotes the special interest of students in the reserved category and to provide special inputs in areas where the students experience difficult.</p>


                                    <p className="text-center"><b>SC/ST Committee (ISBS) A.Y. 2025-26</b></p>
                                    <div className="col-md-12">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>

                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Designation </strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Chairman</td>
                                                    <td>9922802674</td>
                                                    <td>arvind.burande@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Mr. Dayanand Kamble</td>
                                                    <td>Member</td>
                                                    <td>8446104453</td>
                                                    <td>dayanand.kamble@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Member</td>
                                                    <td>9923317264</td>
                                                    <td>manisha.maddel@indiraisbsmba.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Mr. Manoj Singe</td>
                                                    <td>Member</td>
                                                    <td>7349170166</td>
                                                    <td>manoj.singe@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>Mr. Rushikesh Pawade</td>
                                                    <td>Member</td>
                                                    <td>7028062843</td>
                                                    <td>rushikesh.pawade@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>Mr. Shubham Bansode</td>
                                                    <td>Student (MBA 2024–26)</td>
                                                    <td>9834553699</td>
                                                    <td>shubham.bansode@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>Ms. Pratiksha Sayam</td>
                                                    <td>Student (MBA 2024–26)</td>
                                                    <td>7057240750</td>
                                                    <td>pratiksha.sayam@indiraisbs.edu.in</td>
                                                </tr>


                                            </tbody>

                                        </Table>
                                    </div>



                                    {/* <p className="text-center"><b>SC/ST Committee (ISBS) A.Y. 2023-24</b></p>
                                    <div className="col-md-12">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>

                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Designation in Committee</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Komal Singh </td>
                                                    <td>Chairman </td>
                                                    <td>9624038181</td>
                                                    <td><a href="mailto:komal.singh@indiraisbs.ac.in">komal.singh@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Dr. Mrityunjay Kumar</td>
                                                    <td>Section/Liaison Officer </td>
                                                    <td>9987994617</td>
                                                    <td><a href="mailto:mrityunjay.Kumar@indiraisbs.ac.in">mrityunjay.Kumar@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Member </td>
                                                    <td>9922802674</td>
                                                    <td><a href="mailto:arvind.burande@indiraisbs.ac.in">arvind.burande@indiraisbs.ac.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Mr. Dayanand Kambale	</td>
                                                    <td>Member </td>
                                                    <td >9822337422</td>
                                                    <td><a href="mailto:dayanand.kamble@indiraisbs.ac.in">dayanand.kamble@indiraisbs.ac.in</a></td>
                                                </tr>
                                             
                                                <tr>
                                                    <td>5</td>
                                                    <td>Mr. Manoj Singe</td>
                                                    <td>Member </td>
                                                    <td >7349170166</td>
                                                    <td><a href="mailto:manoj.singe@indiraisbs.edu.in">manoj.singe@indiraisbs.edu.in</a></td>
                                                </tr>

                                                <tr>
                                                    <td>6</td>
                                                    <td>Mr. Rushikesh Pawade</td>
                                                    <td>Member </td>
                                                    <td >7028062843</td>
                                                    <td><a href="mailto:rushikesh.pawade@indiraisbs.edu.in">rushikesh.pawade@indiraisbs.edu.in</a></td>
                                                </tr>


                                                <tr>
                                                    <td>7</td>
                                                    <td>Ms. Rashmi Patekar</td>
                                                    <td>Student (MBA 2022-2024)</td>
                                                    <td>9158192887</td>
                                                    <td><a href="mailto:rashmi.patekar@indiraisbs.edu.in">rashmi.patekar@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>Mr. Girish Mohite</td>
                                                    <td>Student (MBA 2022-2024)</td>
                                                    <td >9075771099</td>
                                                    <td><a href="mailto:girish.mohite@indiraisbs.edu.in">girish.mohite@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>Mr. Krutik Khandare</td>
                                                    <td>Student (MBA 2023-2025)</td>
                                                    <td >9665871381</td>
                                                    <td><a href="mailto:krutik.khandare@indiraisbs.edu.in">krutik.khandare@indiraisbs.edu.in</a></td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>Ms. Mayusha Tatale</td>
                                                    <td>Student (MBA 2023-2025)</td>
                                                    <td >9607497713</td>
                                                    <td><a href="mailto:mayusha.tatale@indiraisbs.edu.in">mayusha.tatale@indiraisbs.edu.in</a></td>
                                                </tr>


                                               
                                            </tbody>

                                        </Table>
                                    </div> */}
                                </div>
                            </div>
                        }



                        {studentcounsellor &&
                            <div className="paddingLeft">
                                <div className="col-md-12 padding15px whiteBackground">


                                    <p className="text-center"><b>Student Counsellor Committee 2025-26</b></p>
                                    <div className="col-md-12 ">
                                        <Table class="table table-responsive table-bordered" responsive>

                                            <tbody>

                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Profession & Designation</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>


                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Director In Charge - Chairman</td>
                                                    <td>9922802674</td>
                                                    <td>arvind.burande@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Teaching Faculty - Member</td>
                                                    <td>9923317264</td>
                                                    <td>manisha.maddel@indiraisbsmba.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Prof. Purva Agarwal</td>
                                                    <td>Teaching Faculty - Member</td>
                                                    <td>8308802320</td>
                                                    <td>purva.agarwal@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Ms. Gauri Kulkarni</td>
                                                    <td>NGO Member - Counsellor</td>
                                                    <td>9657998921</td>
                                                    <td>savali.gauri@gmail.com</td>
                                                </tr>


                                            </tbody>

                                        </Table>

                                        <h3 className="blockTitle text-center">Divyang cell 2025-26</h3>
                                        <Table class="table table-bordered table-responsive" responsive>

                                            <tbody>
                                                <tr>
                                                    <td><strong>Sr. No.</strong></td>
                                                    <td class="twidth"><strong>Name of the Committee Members</strong></td>
                                                    <td><strong>Designation in Committee</strong></td>
                                                    <td><strong>Mobile No.</strong></td>
                                                    <td><strong>E-mail-ID</strong></td>
                                                </tr>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Dr. Arvind Burande</td>
                                                    <td>Chairman</td>
                                                    <td>9922802674</td>
                                                    <td>arvind.burande@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Prof. Roopesh Gupta</td>
                                                    <td>Member</td>
                                                    <td>7028922118</td>
                                                    <td>roopesh.gupta@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Dr. Manisha Maddel</td>
                                                    <td>Member</td>
                                                    <td>9923317264</td>
                                                    <td>manisha.maddel@indiraisbsmba.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>4</td>
                                                    <td>Prof. Purva Agarwal</td>
                                                    <td>Member</td>
                                                    <td>8308802320</td>
                                                    <td>purva.agarwal@indiraisbs.ac.in</td>
                                                </tr>
                                                <tr>
                                                    <td>5</td>
                                                    <td>Dr. Vidyadhar Kumbhar (MD Ayurveda, DYA, PGCCR)</td>
                                                    <td>Member</td>
                                                    <td>9960075536</td>
                                                    <td>dr.vidyadhar24@gmail.com</td>
                                                </tr>
                                                <tr>
                                                    <td>6</td>
                                                    <td>Dr. Monika Jaiswal (Primary Health Care Centre - IGI)</td>
                                                    <td>Member</td>
                                                    <td>9552537160</td>
                                                    <td>Sk_kai@yahoo.com</td>
                                                </tr>
                                                <tr>
                                                    <td>7</td>
                                                    <td>Mr. Siddhant Malwal</td>
                                                    <td>Member</td>
                                                    <td>8275196101</td>
                                                    <td>siddhant.malwal@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>8</td>
                                                    <td>Mr. Yash Savadatkar</td>
                                                    <td>Member</td>
                                                    <td>7666413254</td>
                                                    <td>yash.savadatkar@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>9</td>
                                                    <td>Mr. Vijay Babanrao Nalawade</td>
                                                    <td>Member</td>
                                                    <td>9881056938</td>
                                                    <td>arya.nalawade@indiraisbs.edu.in</td>
                                                </tr>
                                                <tr>
                                                    <td>10</td>
                                                    <td>Mr. Sameer Lad</td>
                                                    <td>Member</td>
                                                    <td>8433884466</td>
                                                    <td>sameerlad23@gmail.com</td>
                                                </tr>
                                            </tbody>

                                        </Table>




                                    </div>




                                </div>
                            </div>
                        }





                    </div>
                </div>
            </div>
            <div className="container paddingTop3em paddingBottom3em">
                <div className="row padding15px">
                    <div className="col-md-2 positionAbsolute mobHide">
                        <img src={DrugImage} alt="" className="circleAboutIcon" />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-11 whiteBgWithShadow paddingCommonbox">
                        <img src={DrugImage} alt="" className="circleAboutIconMob1 mobShow" />
                        <h4 className="paddingTop">Drug / Alcohol Policy</h4>
                        <p className="paddingTop">Students of Indira are expected to abstain from drugs and alcohol during their stay at the institute. Violation of this policy
                            will lead to cancellation of admission.</p>
                    </div>
                </div>
                <div className="row padding15px">
                    <div className="col-md-2 positionAbsolute mobHide">
                        <img src={DressImage} alt="" className="circleAboutIcon" />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-11 whiteBgWithShadow paddingCommonbox">
                        <img src={DressImage} alt="" className="circleAboutIconMob1 mobShow" />
                        <h4 className="paddingTop">Dress Code</h4>
                        <p className="paddingTop">At Indira, we believe in inculcating a sense of discipline and belonging in the students by observing a strict dress code.
                            Students are expected to wear formal dress (shirt, trouser & tie for gents; western formals/salwar kameez for ladies)
                            throughout the week, except on Saturdays which will be observed as 'casual-day'. On the occasion of guest lectures, seminars,
                            etc. students are expected to be dressed in the Indira uniform (blazers, tie, shirt, trouser). A student failing to adhere to the
                            dress code will not be allowed to attend lectures and will face strict disciplinary action.
                        </p>
                    </div>
                </div>
                <div className="row padding15px">
                    <div className="col-md-2 positionAbsolute mobHide">
                        <img src={HostelImage} alt="" className="circleAboutIcon" />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-11 whiteBgWithShadow paddingCommonbox">
                        <img src={HostelImage} alt="" className="circleAboutIconMob1 mobShow" />
                        <h4 className="paddingTop">Hostel Rules</h4>
                        <p className="paddingTop">The boys and girls Hostel at Indira have a set of rules which must be adhered to strictly by the students. Each hostel is headed
                            by a warden who acts as a facilitator and observer to maintain discipline in the hostels and ensure its smooth functioning.
                            Students opting to stay in the hostel will have to sign an undertaking in accepting the rules set by the management. Ragging
                            of any type will not be accepted and the concerned students' admissions would be cancelled immediately.
                        </p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ComplianceCommittee